<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5vasmN/tc-custom/9781613127599.jpg?1704761694328" alt="This image is the cover for the book Fluffy Bunnies 2"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fluffy Bunnies 2
      </h1>
      <p class="bookDescription body article font2">
        <b>“Armageddon-averting fun for fans of Jon Scieszka’s Spaceheadz and M.T. Anderson’s Pals in Peril” —from the author of <i>Attack of the Fluffy Bunnies</i> (<i>Kirkus Reviews</i>). </b><br/><br/>When film-loving twins Joules and Kevin Rockman left their summer camp, they thought their days of fighting evil bunnies from outer space were over. Surely there won’t be giant rabbits bent on world domination at their school, right? Wrong. Luckily, these bunnies aren’t FLUFFS (Fierce, Large, Ugly, and Ferocious Furballs)—sugar-addicted giant rabbits out to hypnotize and kill. Unluckily, they’re worse: the FOOFS (Fierce, Obnoxious, Odoriferous Furballs)—seemingly normal-size rabbits (with extra-large noses) out to take over the world! Can Joules and Kevin save themselves, and their school, from the Schnoz of Doom? <br/><br/>Seriously funny <i>New York Times</i>–bestselling author Andrea Beaty raises the stakes in this sequel to her zany, pulpy sci-fi farce. And, not to use Famous Last Words, but with illustrations by Caldecott-winning artist Dan Santat (<i>The Adventures of Beekle</i>, <i>Crankenstein</i>), what could possibly go wrong?<br/><br/><b>Praise for <i>Attack of the Fluffy Bunnies</i></b><br/><br/>“A lighthearted, clever send-up of zany horror conventions, this book is just the thing for kids about ready for M. T. Anderson’s <i>Whales on Stilts</i>.” —<i>Booklist</i><br/><br/>“Beaty’s storytelling is lighthearted and fast-paced . . . her unconventional and entertaining narrative make it a wholly fun read.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrea Beaty, Dan Santat
      </h2>
      
      <p class="authorDescription body article">Andrea Beaty is the New York Times bestselling author of many children’s books, including Rosie Revere, Engineer and Attack of the Fluffy Bunnies www.andreabeaty.com. Dan Santat is the author and illustrator of many books, including The Guild of Geniuses and Sidekicks. He won a Caldecott Medal for his book The Adventures of Beekle. www.dantat.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Abrams
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a764e09a